module.exports = __webpack_public_path__ + "static/img/dz01.b7cc1a8b.png";